import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './relaxing-after-work.component.html',
  styleUrls: ['./relaxing-after-work.component.scss']
})
export class RelaxingAfterWorkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
